var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHighlightStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.37 12.24c.11-.1.15-.24.11-.38a.366.366 0 00-.3-.26l-5.74-.91-2.59-4.97a.383.383 0 00-.33-.2c-.14 0-.27.08-.33.2L8.6 10.69l-5.76.91c-.14.02-.26.12-.3.26-.04.14 0 .28.11.38l4.36 3.85-1.2 5.95c-.03.14.03.28.14.37.11.08.27.1.39.03l5.14-2.61 5.14 2.61c.13.07.28.05.39-.03.11-.08.17-.23.15-.37L16 16.09l4.37-3.85zm6.95 7.12l-2.87-.43-1.3-2.34c-.04-.06-.1-.09-.17-.09s-.13.04-.17.09l-1.3 2.34-2.87.43c-.07.01-.13.05-.15.12-.02.07 0 .14.05.18l2.18 1.81-.6 2.8a.186.186 0 00.27.19l2.57-1.23 2.57 1.23c.06.03.14.03.19-.01.06-.04.09-.11.08-.18l-.58-2.8 2.18-1.81c.05-.04.07-.12.05-.18-.01-.07-.06-.12-.13-.12z"
  })));
}

export default SvgHighlightStars;